if (!customElements.get('stars-love-us-modal')) {
  customElements.define(
    'stars-love-us-modal',
    class StarsLoveUsModal extends ModalDialog {
      constructor() {
        super();

        this.image = this.querySelector('.stars-modal__image');
        this.currentIndex = 0;
        this.triggers = [];
        this.currentProductUrl = null;

        this.image.addEventListener('click', () => {
          if (this.currentProductUrl) window.location.href = this.currentProductUrl;
        });

        const prev = this.querySelector('[data-stars-prev]');
        const next = this.querySelector('[data-stars-next]');
        if (prev) prev.addEventListener('click', () => this.step(-1));
        if (next) next.addEventListener('click', () => this.step(1));

        this.addEventListener('keyup', ({ code }) => {
          if (code === 'ArrowLeft') this.step(-1);
          else if (code === 'ArrowRight') this.step(1);
        });
      }

      connectedCallback() {
        super.connectedCallback();

        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;
        const sectionRoot = document.getElementById(`shopify-section-${sectionId}`);
        if (!sectionRoot) return;

        this.triggers = [...sectionRoot.querySelectorAll('[data-stars-trigger]')];

        this.triggers.forEach((trigger, index) => {
          if (trigger.dataset.starsBound === 'true') return;
          trigger.dataset.starsBound = 'true';
          trigger.addEventListener('click', () => {
            this.currentIndex = index;
            this.show(trigger);
          });
        });

        this.toggleAttribute('data-single', this.triggers.length <= 1);
      }

      show(opener) {
        const trigger = this.triggers[this.currentIndex];
        if (trigger) this.applyImageFrom(trigger);
        super.show(opener);
      }

      step(direction) {
        if (this.triggers.length < 2) return;
        this.currentIndex = (this.currentIndex + direction + this.triggers.length) % this.triggers.length;
        this.applyImageFrom(this.triggers[this.currentIndex]);
      }

      applyImageFrom(trigger) {
        if (!this.image || !trigger) return;
        const { popupSrc, popupSrcset, popupAlt, popupWidth, popupHeight, productUrl } = trigger.dataset;

        if (popupSrcset) {
          this.image.srcset = popupSrcset;
        } else {
          this.image.removeAttribute('srcset');
        }
        if (popupWidth) this.image.width = popupWidth;
        if (popupHeight) this.image.height = popupHeight;
        this.image.alt = popupAlt || '';
        this.image.src = popupSrc || '';

        this.currentProductUrl = productUrl || null;
        this.image.style.cursor = this.currentProductUrl ? 'pointer' : '';
      }
    }
  );
}
